import i18n from "@/plugins/i18n";
import datasetDiscountType from "@/datasets/discountType";
import moment from "moment";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Key",
          value: "key",
        },
        {
          text: "Discount Type",
          value: "discountType",
        },
        {
          text: "Discount Value",
          value: "discountValue",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
      {
        key: 'CouponPlan',
        label:  'Plans',
      },
    ],
    table: {
      headers: [
        {
          text: "Key",
          value: "key",
        },
        {
          text: "Discount Type",
          value: "discountType",
        },
        {
          text: "Discount Value",
          value: "discountValue",
        },
        {
          text: "Start Date",
          value: "timestampStart",
          filterable: false,
        },
         {
          text: "End Date",
          value: "timestampEnd",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "string",
        key: "key",
        name: "Key",
        defaultValue: "",
      },
      {
        type: "select",
        key: "discountType",
        name: "Discount Type",
        options: datasetDiscountType,
        optionText: "name",
        optionValue: "value",
        defaultValue: "percentage",
      },
      {
        type: "number",
        key: "discountValue",
        name: "DiscountvValue",
        min: 1,
        max: 100,
        defaultValue: 20,
      },
           {
        type: "date",
        key: "dateStart",
        name: "Date Start",
        min: moment().format("YYYY-MM-DD"),
        defaultValue: null,
      },
      {
        type: "date",
        key: "dateEnd",
        name: "Date End",
        min: moment().format("YYYY-MM-DD"),
        defaultValue: null,
      },
    ],
    rules: {
      key: [(v) => !!v || "Key is required"],
    },
  },
  edit: true,
  delete: true,
};
